import React from 'react';

import Transcription from '../Transcription';

import './AudioPlayer.scss';

type Props = {
  transcription?: string;
  sources: Array<string>;
  className?: string;
  withoutTranscription?: boolean;
};

function AudioPlayer({
  sources,
  transcription,
  className = '',
  withoutTranscription = false,
}: Props): React.ReactElement {
  return (
    <div className={`AudioPlayer d-flex ${className}`}>
      <audio controls className="AudioPlayer__preview">
        {sources.map(source => source && <source src={source} />)}
      </audio>
      {withoutTranscription ? null : <Transcription text={transcription} />}
    </div>
  );
}

export default AudioPlayer;
